import React from 'react'
import { Link } from 'react-router-dom'
import DatanotFound from '../../../components/DatanotFound/DatanotFound'
import Skeleton from 'react-loading-skeleton'

const Profiledetails = ({ isActiveTab, data, isFetching }) => {
    return (
        <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>
            <div className="Headingforallheader">
                <div className="flex-between w-100">
                    <h2 className="heading-2">Profile Details</h2>
                </div>
            </div>

            <div className="border-btm w-100"></div>

            <div className="bodyDataForallUserdata Adfixwidthalldata">
                <div className="profileDetailsWrap">
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'First Name'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.firstName ? data?.firstName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Last Name'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.lastName ? data?.lastName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Designation'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.designation ? data?.profession?.designation : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : 'Current Company'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.company ? data?.profession?.company : "---"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Phone Number'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.mobileNumber ? data?.mobileNumber : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Email'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.email ? data?.email : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Linkedin'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"200px"} /> : data?.linkedin ? <a className='SocialLink' target='_blank' to={data?.linkedin.slice(0,4) === "http" ? data?.linkedin : "https://" + data?.linkedin} rel='noreferrer'>
                                {data?.linkedin}
                            </a> : <span>{"---"}</span>}
                        </div>
                    </div>
                    <div className="dashedDivider"></div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'About'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"500px"} /> : data?.about ? data?.about : "---"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Years of Experience'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.yrsOfExp ? `${data?.profession?.yrsOfExp}+ years` : "---"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Functional focus area'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            <div className="dataexpertise">
                                {isFetching ? <Skeleton width={"300px"} /> : data?.interests?.length > 0 ? data?.interests?.map((item, index) => (
                                    <div className='text2' key={index}>{item?.interest ? item?.interest : "---"}</div>
                                )) : <DatanotFound />}
                            </div>
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : 'Mentoring On'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            <div className="dataexpertise">
                                {isFetching ? <Skeleton width={"300px"} /> : data?.topics?.length > 0 ? data?.topics?.map((item, index) => (
                                    <div className='text2' key={index}>{item?.Topic ? item?.Topic : "---"}</div>
                                )) : <DatanotFound />}
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default Profiledetails
